import { render, staticRenderFns } from "./LunchMenuItem.vue?vue&type=template&id=206cf155&"
import script from "./LunchMenuItem.vue?vue&type=script&lang=js&"
export * from "./LunchMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports